export const paths = [{ "tag": "path", "att": { "d": "M19 12 7 19V5l12 7z" } }];
export const iconName = 'play';
export const play = { iconName, paths };
export default paths;
